import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-relative tw-inline-flex tw-cursor-pointer tw-items-center tw-transform" }

import { computed, ref } from 'vue';


    
export default /*#__PURE__*/_defineComponent({
  __name: 'Toggle',
  props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        }
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

    const emit = __emit;
    const value = computed({
        get() {
            return props.modelValue;
        },
        set(value: boolean) {
            emit('update:modelValue', value);
        }
    });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      class: "tw-sr-only"
    }, null, 512), [
      [_vModelCheckbox, value.value]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["tw-h-[20px] tw-w-[32px] tw-rounded-full tw-transition-colors", value.value ? 'tw-bg-brand-700' : 'tw-bg-slate-300'])
    }, null, 2),
    _createElementVNode("span", {
      class: "tw-absolute tw-left-0 tw-top-0 tw-m-[2px] tw-h-[16px] tw-w-[16px] tw-rounded-full tw-bg-white tw-border tw-border-gray-300 tw-transition-transform tw-duration-200 tw-ease-in-out",
      style: _normalizeStyle({ transform: value.value ? 'translateX(12px)' : 'translateX(0)' })
    }, null, 4)
  ]))
}
}

})